<template>
  <v-content class="rating-header">
    <v-container class="rating-header__logo mt-4">
      <v-img src="/img/logo.gif" :aspect-ratio="ratio" contain class="logo d-flex align-start" />
    </v-container>
  </v-content>
</template>
<script>
export default {
  name: 'RatingHeader',
  props: {
    ratio: {
      required: true
    }
  },
  computed: {
    currentDate () {
      const months = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec']
      let today = new Date()
      let month = months[today.getMonth()]
      let day = today.getDate()
      let year = today.getFullYear()

      return day + ' ' + month + ' ' + year
    }
  }
}
</script>
<style lang="scss">
.rating-header {

  .logo {
    animation: pulse 5s cubic-bezier(0.455, 0.03, 0.515, 0.955) .4s infinite;
  }
  @keyframes pulse {
    0% {
      filter: drop-shadow(2px 2px 2px #222);
      transform: scale(.97);
    }
    50% {
      filter: drop-shadow(2px 2px 6px #666);
      transform: scale(1);
    }
    100% {
      filter: drop-shadow(2px 2px 2px #222);
      transform: scale(.97);
    }
  }
}
</style>
